import OwnableTheme from '@Theme';
import { AntDesign } from '@expo/vector-icons';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components/native';

import { useFloorMapPresenter } from '../FloorMapPresenter';

type Props = {
  size?: number;
};

export const MapCloseButton = observer(function MapCloseButton({
  size = 36,
}: Props) {
  const { setExtendedMapVisible } = useFloorMapPresenter();

  return (
    <IconWrapper
      onPress={() => {
        setExtendedMapVisible(false);
      }}
      style={{ width: size, height: size }}
    >
      <AntDesign name='close' size={(19 / 36) * size} color='white' />
    </IconWrapper>
  );
});

const IconWrapper = styled.Pressable`
  background-color: ${OwnableTheme.colors.black};
  width: 36px;
  height: 36px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
`;
